import API from '../../../utils/API';
import { Post, Get, Put, Patch, Delete } from '../../../utils/callApi';

export const getDataReportStorage = async (body) => {
  const { success, data } = await Post(API.REPORT.STORAGE.GET_DATA, body);
  if(success) {
    if(data.ErrorCode === 0){
      return {
        success: true,
        data: data.Result,
      }
      ;
    }

    if(data.ErrorCode === 404){
      return {
        success: false,
        data: {
          isNotFound: true,
          isFail: false,
        }
      }
    }
    
    return {
      success: false,
      data: {
        isNotFound: false,
        isFail: true,
      }
    }
  } else {
    return {
      success: false,
      data: {
        isNotFound: false,
        isFail: true,
      }
    };
  }
}

export const getDataReportFile = async (body) => {
  const { success, data } = await Post(API.REPORT.FILE.GET_DATA, body);
  if(success) {
    if(data.ErrorCode === 0){
      return {
        success: true,
        data: data.Result,
      };
    }

    if(data.ErrorCode === 404){
      return {
        success: false,
        data: {
          isNotFound: true,
          isFail: false,
        } 
      };
    }
    
    return {
      success: false,
      data: {
        isNotFound: false,
        isFail: true,
      }
    };
  } else {
    return {
      success: false,
      data: {
        isNotFound: false,
        isFail: true,
      }
    };
  }
}


export const getDataReportCard = async () => {
  const { success, data } = await Get(API.REPORT.DASHBOARD);
  if(success) {
    if(data.ErrorCode === 0){
      return {
        success: true,
        data: data.Result,
      };
    }
    return {
      success: false,
      data: []
    };
  } else {
    return {
      success: false,
      data: []
    };
  }
}

